import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgScrollbar } from 'ngx-scrollbar';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { DropdownComponent } from '../../../../inputs/dropdown/dropdown.component';
import { FloatingInputComponent } from '../../../../inputs/floating-input/floating-input.component';
import { InputCalendarComponent } from '../../../../inputs/input-calendar/input-calendar.component';
import { SimpleButtonComponent } from '../../../../buttons/simple-medium-button/simple-button.component';
import { UploadWindowComponent } from '@app/framework/file-handling/upload-window/upload-window.component';
import { PrimeContractModel } from '@app/store/prime-commitments/prime-commitments.types';
import { primeContractStatuses } from '@app/store/prime-commitments/prime-commitments.constants';
import { primeContractActions } from '@app/store/prime-commitments/prime-commitments.actions';
import { viewProjectSelectors } from '@app/store/view-project/view-project.selectors';
import { FloatingTextareaComponent } from '@app/framework/inputs/floating-textarea/floating-textarea.component';
import { isPersistedFile, ManagedFile } from '@app/framework/interfaces/file.type';
import { InputUploadComponent } from '@app/framework/file-handling/input-upload/input-upload.component';

@Component({
  selector: 'app-prime-contract-general-page',
  imports: [
    DropdownComponent,
    FloatingInputComponent,
    FormsModule,
    InputCalendarComponent,
    SimpleButtonComponent,
    NgScrollbar,
    AsyncPipe,
    FloatingTextareaComponent,
    InputUploadComponent,
  ],
  templateUrl: './prime-contract-general-page.component.html',
  styleUrl: './prime-contract-general-page.component.scss',
})
export class PrimeContractGeneralPageComponent {
  private readonly store = inject(Store);

  @Input() model: PrimeContractModel;
  @Output() modelChange = new EventEmitter<PrimeContractModel>();
  @ViewChild('fileUpload') fileUpload: UploadWindowComponent;
  @ViewChild('generalPage') generalPage: NgForm;

  protected readonly statuses = primeContractStatuses;
  protected readonly project$ = this.store.select(viewProjectSelectors.getSelectedProject);

  filesChanged(files: ManagedFile[]) {
    this.model.files = files;
    console.log('files changed:', this.model.files);
    this.modelChange.emit(this.model);
  }

  removeFile({ file, index }: { file: ManagedFile; index: number }) {
    if (isPersistedFile(file)) {
      this.model.files = this.model.files.map((modelFile) => {
        if (isPersistedFile(modelFile) && modelFile.id === file.id) {
          modelFile.toBeDeleted = true;
        }
        return modelFile;
      });
    } else {
      this.model.files = this.model.files.filter((_, modelIndex) => modelIndex !== index);
    }

    this.modelChange.emit(this.model);
  }

  isFormValid() {
    this.generalPage.form.markAllAsTouched();
    return this.generalPage.form.valid;
  }

  goToNextPage() {
    if (!this.isFormValid()) {
      return;
    }

    this.store.dispatch(primeContractActions.onPrimeContractClickNext());
  }
}
